import { render, staticRenderFns } from "./AddBlogCategory.vue?vue&type=template&id=19bcec9c&scoped=true&"
import script from "./AddBlogCategory.vue?vue&type=script&lang=js&"
export * from "./AddBlogCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bcec9c",
  null
  
)

export default component.exports